import { CardContentStyle, CardStyle } from '@common/components/_pages/styles'
import { addApolloState, initializeApollo } from '@palqee/apollo-client'

import { AuthFormWrapper } from '@features/auth/components/auth-form/styles'
import { AuthLayout } from '@layouts/auth-layout'
import Brand from '@common/components/brand'
// src
import { Card } from '@common/components/card'
import ForgotPasswordRecoverForm from '@features/auth/components/auth-form/forgot-password/init-step'
import { NextPage } from 'next'
import { TPageProps } from '@app-page/types'

const ForgotPasswordPage: NextPage<{}> & TPageProps = () => {
  return (
    <AuthFormWrapper className="AuthForm">
      <ForgotPasswordRecoverForm />
    </AuthFormWrapper>
  )
}

ForgotPasswordPage.getLayout = (page) => {
  return (
    <AuthLayout backgroundIcon="welcome-full">
      <Card css={CardStyle}>
        <Card.Content css={CardContentStyle}>{page}</Card.Content>
      </Card>

      <Brand.CopyRight />
    </AuthLayout>
  )
}
ForgotPasswordPage.getInitialProps = (ctx) => {
  const client = initializeApollo(ctx)
  return addApolloState(client, {})
}

export default ForgotPasswordPage
